import { TextField } from "components/TextField";
import { InputAdornment } from "@mui/material";
import React from "react";
import { NO_VALUE_ERROR } from "components/CaseManagement/CaseDetail/MetaDataTable/MetaDataEditField";

const validateTextValue = (value: string): string | undefined => {
  if (!value || value.length === 0) {
    return NO_VALUE_ERROR;
  }

  return undefined;
};

export interface AttributeTextFieldProps {
  value: string;
  onChangeValue: (value: string) => void;
  error: string | undefined;
  onError: (message: string) => void;
  onClearError: () => void;
  enableLabel: boolean;
  size: "small" | "medium";
  dense: boolean;
  placeholder?: string;
  inputAdornment?: React.ReactNode;
}

export const AttributeTextField = ({
  value,
  onChangeValue,
  error,
  onError,
  onClearError,
  enableLabel,
  size,
  dense,
  placeholder,
  inputAdornment
}: AttributeTextFieldProps): JSX.Element => {
  const handleAttributeChanged = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const errorMessage = validateTextValue(event.target.value);

    if (errorMessage !== undefined) {
      onError(errorMessage);
    } else {
      onClearError();
    }

    onChangeValue(event.target.value);
  };

  return (
    <TextField
      fullWidth
      size={size ?? "medium"}
      margin={dense ? "dense" : "none"}
      error={Boolean(error)}
      helperText={error}
      label={enableLabel ? "Attribute Value" : ""}
      value={value}
      onChange={handleAttributeChanged}
      aria-label="meta value input"
      placeholder={placeholder}
      data-qa="CM-Text-Attribute-Value"
      InputProps={{
        endAdornment: inputAdornment ? (
          <InputAdornment position="end">{inputAdornment}</InputAdornment>
        ) : null
      }}
    />
  );
};
